import { ReportFormatEnum } from "shared/api";

export enum ReportsSorting {
  NAME_ASC = "name",
  NAME_DESC = "-name",
  TEMPLATE_ID_ASC = "template_id",
  TEMPLATE_ID_DESC = "-template_id",
  REPORT_TYPE_ASC = "report_type",
  REPORT_TYPE_DESC = "-report_type",
  REPORT_CATEGORY_ASC = "report_category__name",
  REPORT_CATEGORY_DESC = "-report_category__name",
  CARBONE_TYPE_ASC = "carbone_type",
  CARBONE_TYPE_DESC = "-carbone_type",
  IS_DEFAULT_ASC = "is_default",
  IS_DEFAULT_DESC = "-is_default",
  VISIBLE_ASC = "visible",
  VISIBLE_DESC = "-visible",
}

export const initialExecuteReportValues = {
  id: null,
  material_item_id: null,
  packaging_id: null,
  order_id: null,
  material_id: null,
  // order_wanted_delivery_datetime_start: null,
  // order_wanted_delivery_datetime_end: null,
  order_production_datetime_start: null,
  order_production_datetime_end: null,
  report_format: ReportFormatEnum.PDF,
  quality_result_id: null,
  packaging_ids: [],

  drigging_rigg_field: null,
  drigging_rigg_datetime_start: null,
  drigging_rigg_datetime_end: null,
  drigging_rigg_n_points: null,

  company_id: null,
  material_category_id_list: [],
  order_ids: [],
  material_category_id: null,
  dynamic_tracker_fields: [],

  // Reel Lab Result Multiple fields
  quality_result_material_item_timestamp_start: null,
  quality_result_material_item_timestamp_end: null,
  product_card_id: null,
};

export const initialReportCategoriesValues = {
  id: null,
  name: "",
};

export const reportFileFormats = [
  {
    label: "Basic Formats",
    title: "Basic Formats",
    options: [
      {
        label: ReportFormatEnum.PDF.toUpperCase(),
        value: ReportFormatEnum.PDF,
      },
      {
        label: ReportFormatEnum.DOCX.toUpperCase(),
        value: ReportFormatEnum.DOCX,
      },
      {
        label: ReportFormatEnum.XLSX.toUpperCase(),
        value: ReportFormatEnum.XLSX,
      },
    ],
  },
  {
    label: "Other Formats",
    title: "Other Formats",
    options: [
      {
        label: ReportFormatEnum.ODS.toUpperCase(),
        value: ReportFormatEnum.ODS,
      },
      {
        label: ReportFormatEnum.XLS.toUpperCase(),
        value: ReportFormatEnum.XLS,
      },
      {
        label: ReportFormatEnum.CSV.toUpperCase(),
        value: ReportFormatEnum.CSV,
      },
      {
        label: ReportFormatEnum.TXT.toUpperCase(),
        value: ReportFormatEnum.TXT,
      },
      {
        label: ReportFormatEnum.ODP.toUpperCase(),
        value: ReportFormatEnum.ODP,
      },
      {
        label: ReportFormatEnum.PPT.toUpperCase(),
        value: ReportFormatEnum.PPT,
      },
      {
        label: ReportFormatEnum.PPTX.toUpperCase(),
        value: ReportFormatEnum.PPTX,
      },
      {
        label: ReportFormatEnum.JPG.toUpperCase(),
        value: ReportFormatEnum.JPG,
      },
      {
        label: ReportFormatEnum.PNG.toUpperCase(),
        value: ReportFormatEnum.PNG,
      },
      {
        label: ReportFormatEnum.ODT.toUpperCase(),
        value: ReportFormatEnum.ODT,
      },
      {
        label: ReportFormatEnum.DOC.toUpperCase(),
        value: ReportFormatEnum.DOC,
      },
      {
        label: ReportFormatEnum.EPUB.toUpperCase(),
        value: ReportFormatEnum.EPUB,
      },
      {
        label: ReportFormatEnum.HTML.toUpperCase(),
        value: ReportFormatEnum.HTML,
      },
      {
        label: ReportFormatEnum.XML.toUpperCase(),
        value: ReportFormatEnum.XML,
      },
      {
        label: ReportFormatEnum.IDML.toUpperCase(),
        value: ReportFormatEnum.IDML,
      },
    ],
  },
];

export const templateFormatAllowedFormats: Record<string, ReportFormatEnum[]> =
  {
    DOCX: [ReportFormatEnum.PDF, ReportFormatEnum.DOCX, ReportFormatEnum.ODT],
    XLSX: [ReportFormatEnum.PDF, ReportFormatEnum.XLSX],
    OTHER: Object.values(ReportFormatEnum),
  };

export const mimeTypeMap: { [key: string]: string } = {
  ods: "application/vnd.oasis.opendocument.spreadsheet",
  xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  xls: "application/vnd.ms-excel",
  csv: "text/csv",
  pdf: "application/pdf",
  txt: "text/plain",
  odp: "application/vnd.oasis.opendocument.presentation",
  ppt: "application/vnd.ms-powerpoint",
  pptx: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  jpg: "image/jpeg",
  png: "image/png",
  odt: "application/vnd.oasis.opendocument.text",
  doc: "application/msword",
  docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  epub: "application/epub+zip",
  html: "text/html",
  xml: "application/xml",
  idml: "application/vnd.adobe.indesign-idml-package",
};
